import styled, { css } from 'styled-components';
export const StyledFooter = styled.footer `
  ${({ theme }) => theme.getFontStyle('samsung-400-12')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${({ theme }) => theme.getColor('gray', '02')};
  height: 6rem;

  ${(props) => props.$page === 'admin-dashboard' &&
    css `
      padding: 0 3rem;
    `}

  ${(props) => props.$page === 'login' &&
    css `
      padding: 0 8rem;
    `}
`;
//# sourceMappingURL=Footer.styles.js.map